<template>
	<div class="header-container">
		<div class="header-title-container display-flex flex-justify-space-between flex-align-center">
			{{ formTitle }}
		</div>
		<div v-if="showExpandedMenu || showMiniApps" class="back-to-full-menu flex-row flex-start--center">
			<v-btn @click="hideFullMenu" class="back-button" width="25" height="25" fab x-small>
				<AppIcon name="back" />
			</v-btn>
			Back
		</div>
		<AppActionSearchField
			v-on="$listeners"
			class="search-field"
			v-model="localSearchString"
			:placeholder="showExpandedMenu ? `Search ${showExpandedMenu[0].toUpperCase() + showExpandedMenu.slice(1)}` : 'Search'"
			:loading="loading"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import AppActionSearchField from './AppActionSearchField';
import { isNullOrUndefined } from '@/utils/helpers';

export default {
	name: 'AddNewStepHeader',
	components: {
		AppActionSearchField,
	},
	props: {
		searchString: { type: String },
		showMiniApps: { type: Boolean },
		showExpandedMenu: { type: [Boolean, String] },
		loading: { type: Boolean },
	},
	computed: {
		...mapGetters(['selectedNode/editNode']),
		formTitle() {
			if (this.showExpandedMenu) {
				return `Choose ${this.showExpandedMenu}`;
			} else {
				return this.serviceDefined ? 'Edit step' : 'Add new step';
			}
		},
		serviceDefined() {
			return !isNullOrUndefined(this['selectedNode/editNode'].service);
		},
		localSearchString: {
			set(value) {
				this.$emit('update:searchString', value);
			},
			get() {
				return this.searchString;
			},
		},
	},
	methods: {
		hideFullMenu() {
			this.$emit('hide-full-menu');
		},
	},
};
</script>

<style scoped lang="scss">
.header-container {
	width: 100%;
	font-size: 16px;
	font-weight: bold;
	color: var(--bold-title);
	padding: 40px 20px 15px 20px;

	.header-title-container {
		width: 100%;
		text-transform: capitalize;
	}

	.back-to-full-menu {
		width: 100%;
		font-size: 14px;
		font-weight: normal;

		.back-button {
			display: flex;
			border-radius: 6px;
			align-items: center;
			justify-content: center;
			margin: 5px 5px 5px 0px;
			border: 1px solid var(--grey-background);
		}
	}

	.search-field {
		font-size: 14px;
		font-weight: normal;

		&:hover {
			background-color: var(--app-selection-hover-background);
		}
	}
}
</style>
